import { render, staticRenderFns } from "./InviteTeam.vue?vue&type=template&id=259bf67b&scoped=true&"
import script from "./InviteTeam.vue?vue&type=script&lang=js&"
export * from "./InviteTeam.vue?vue&type=script&lang=js&"
import style0 from "./InviteTeam.vue?vue&type=style&index=0&id=259bf67b&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "259bf67b",
  null
  
)

export default component.exports